import Link from "next/link";
import MyButton from '../../../../myButton';
import styles from './styles.module.scss';

const DonateTrigger = () => {
  return (
    <div className={styles.Stub}>
      <h5 className={styles.Stub__title}>
        Поддержите <span>DonorSearch</span>
      </h5>
      <Link
        href="/donate/?utm_source=lkdonor&utm_medium=ds&utm_campaign=donor_search"
        style={{ width: "100%" }}
      >
        <MyButton text={"Оформить пожертвование"} width="100%" />
      </Link>
    </div>
  );
}

export default DonateTrigger;